/* eslint-disable import/order */
/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT DIRECTLY.
 * See libs/messenger/codegen/generators/typescript.py for more information.
 */
import {
  type CameraBotService,
  CameraDeviceListResult,
  CameraDevice,
  CameraDeviceResult,
  DeviceConfiguration,
  CameraId,
  CameraMetadataResult,
  GetFrameRequest,
  CameraFrameResult,
  GetCameraIntrinsicsRequest,
  CameraIntrinsicsResult,
  GetCameraExtrinsicsRequest,
  CameraExtrinsicsResult,
  CameraFrame,
  protoMetadata,
} from '../../auto_generated/messenger/camera_bot_service';
import type { MessengerNode, SubscriptionToken } from '../../node';

import { DefaultConnector } from './DefaultConnector';
import { Empty } from "../../auto_generated/google/protobuf/empty";


/**
 * Connector for the CameraBotService
 * Extends DefaultConnector and provides type-safe methods for CameraBotService operations
 */
export class CameraBotConnector
  extends DefaultConnector
  implements CameraBotService
{

  /** Runtime map: method → request/response constructors */
  public static readonly methodMeta = {
    ...DefaultConnector.methodMeta,
    GetDiscoveredDevices: { requestType: Empty, responseType: CameraDeviceListResult },
    SetDeviceEnabled: { requestType: CameraDevice, responseType: CameraDeviceResult },
    ConfigureDevice: { requestType: DeviceConfiguration, responseType: CameraDeviceResult },
    GetDeviceMetadata: { requestType: CameraId, responseType: CameraMetadataResult },
    GetDevice: { requestType: CameraId, responseType: CameraDeviceResult },
    GetFrame: { requestType: GetFrameRequest, responseType: CameraFrameResult },
    GetCameraIntrinsics: { requestType: GetCameraIntrinsicsRequest, responseType: CameraIntrinsicsResult },
    GetCameraExtrinsics: { requestType: GetCameraExtrinsicsRequest, responseType: CameraExtrinsicsResult },
  } as const;


  /** Runtime map: topic → message constructor */
  public static readonly topicMeta = {
    ...DefaultConnector.topicMeta,
    CameraStream: { topicType: CameraFrame },
  } as const;



  /** Protobuf metadata for runtime schema introspection */
  public static readonly protoMetadata = protoMetadata;

  /**
   * Create a new CameraBotConnector
   * @param messengerNode - The MessengerNode instance to use for communication
   * @param serviceKey - The service key for the service
   * @param peerId - Optional peer ID for routing requests
   */
  public constructor(
    messengerNode: MessengerNode,
    serviceKey: string = 'camerabot',
    peerId?: string,
  ) {
    super(messengerNode, serviceKey, peerId);
  }

  /**
   * Calls the GetDiscoveredDevices method on the service.
   */
  public async GetDiscoveredDevices(params: Empty, timeoutMs?: number): Promise<CameraDeviceListResult> {
    return this.request<Empty, CameraDeviceListResult>('GetDiscoveredDevices', params, Empty, CameraDeviceListResult, timeoutMs);
  }

  /**
   * Calls the SetDeviceEnabled method on the service.
   */
  public async SetDeviceEnabled(params: CameraDevice, timeoutMs?: number): Promise<CameraDeviceResult> {
    return this.request<CameraDevice, CameraDeviceResult>('SetDeviceEnabled', params, CameraDevice, CameraDeviceResult, timeoutMs);
  }

  /**
   * Calls the ConfigureDevice method on the service.
   */
  public async ConfigureDevice(params: DeviceConfiguration, timeoutMs?: number): Promise<CameraDeviceResult> {
    return this.request<DeviceConfiguration, CameraDeviceResult>('ConfigureDevice', params, DeviceConfiguration, CameraDeviceResult, timeoutMs);
  }

  /**
   * Calls the GetDeviceMetadata method on the service.
   */
  public async GetDeviceMetadata(params: CameraId, timeoutMs?: number): Promise<CameraMetadataResult> {
    return this.request<CameraId, CameraMetadataResult>('GetDeviceMetadata', params, CameraId, CameraMetadataResult, timeoutMs);
  }

  /**
   * Calls the GetDevice method on the service.
   */
  public async GetDevice(params: CameraId, timeoutMs?: number): Promise<CameraDeviceResult> {
    return this.request<CameraId, CameraDeviceResult>('GetDevice', params, CameraId, CameraDeviceResult, timeoutMs);
  }

  /**
   * Calls the GetFrame method on the service.
   */
  public async GetFrame(params: GetFrameRequest, timeoutMs?: number): Promise<CameraFrameResult> {
    return this.request<GetFrameRequest, CameraFrameResult>('GetFrame', params, GetFrameRequest, CameraFrameResult, timeoutMs);
  }

  /**
   * Calls the GetCameraIntrinsics method on the service.
   */
  public async GetCameraIntrinsics(params: GetCameraIntrinsicsRequest, timeoutMs?: number): Promise<CameraIntrinsicsResult> {
    return this.request<GetCameraIntrinsicsRequest, CameraIntrinsicsResult>('GetCameraIntrinsics', params, GetCameraIntrinsicsRequest, CameraIntrinsicsResult, timeoutMs);
  }

  /**
   * Calls the GetCameraExtrinsics method on the service.
   */
  public async GetCameraExtrinsics(params: GetCameraExtrinsicsRequest, timeoutMs?: number): Promise<CameraExtrinsicsResult> {
    return this.request<GetCameraExtrinsicsRequest, CameraExtrinsicsResult>('GetCameraExtrinsics', params, GetCameraExtrinsicsRequest, CameraExtrinsicsResult, timeoutMs);
  }

  /**
   * Subscribe to the CameraStream topic
   * @param callback - Callback function to be called when a message is received
   * @param index - Optional topic index (default "")
   */
  public subscribeToCameraStream(
    callback: (message: CameraFrame) => void,
    index: string = ""
  ): SubscriptionToken {
    return this.subscribe(
      `CameraStream/${index}`,
      callback,
      CameraFrame
    );
  }

  /**
   * Unsubscribe from the CameraStream topic
   * @param index - Optional topic index (default "")
   * @param token - Token from subscribeToCameraStream; omit to remove every callback for the key
   */
  public unsubscribeFromCameraStream(index: string = "", token?: SubscriptionToken): void {
    return this.unsubscribe(
      `CameraStream/${index}`,
      token
    );
  }

}
